import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_EMPLOYMENT, CANDIDATE_EMPLOYMENT_PARAM } from "../../../common/URLs";

export const candidateExp = async (token) => {
  try {
    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_EMPLOYMENT_PARAM}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    // console.log("response async : ", data);
    return data.response;
  } catch (error) {
    console.log("Error in making the fetch request: ", error);
  }
};

export const deleteExp = async (token, uuid) => {
  try {
    const respone = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_EMPLOYMENT}/${uuid}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "application/json",
        },
      }
    );

    const data = await respone.json();
    console.log("response after delete request:- ", data);
    return data;
  } catch (error) {
    console.log("Error in making the delete request: ", error);
  }
};
